import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=78244f32&scoped=true&"
import script from "./addClassify.vue?vue&type=script&lang=js&"
export * from "./addClassify.vue?vue&type=script&lang=js&"
import style0 from "./addClassify.vue?vue&type=style&index=0&id=78244f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78244f32",
  null
  
)

export default component.exports